import Sidebar from './Sidebar';
import Navbar from './Navbar';
import React from 'react';
import './style.css';
import Table from 'react-bootstrap/Table';

import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";


const EditClient = () => {

    const navigate = useNavigate();

    const [inputs, setInputs] = useState([]);

    const {id} = useParams();

    useEffect(() => {
        getUser();
    }, []);

    function getUser() {
        axios.get(`https://react-apis.dotlocalhost.com/clientShow.php/${id}`).then(function(response) {
            console.log(response.data);
            setInputs(response.data);
        });
    }

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs(values => ({...values, [name]: value}));
    }
    const handleSubmit = (event) => {
        event.preventDefault();

        axios.put(`https://react-apis.dotlocalhost.com/clientShow.php/${id}/edit`, inputs).then(function(response){
            console.log(response.data);
            alert('Record have been updated succefully!');
            navigate('/viewclient');
        });    
    }

    return(
        <div class="wrapper">
            <Sidebar/>
            <div id="content">
                <Navbar />

                <div className='ineerBody'>

                    <div className='row'>
                        <div className='col-md-12 mb-5'>
                            <h3>Edit Clients</h3>
                        </div>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <Table cellSpacing="10">
                            <tbody>
                                <tr>
                                    <th>
                                        <label>Client Name: </label>
                                    </th>
                                    <td>
                                        <input value={inputs.clientName} type="text" className='form-control' name="clientName" onChange={handleChange} />
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <label>Address: </label>
                                    </th>
                                    <td> 
                                        <input value={inputs.address} type="text" className='form-control' name="address" onChange={handleChange} />
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <label>Email: </label>
                                    </th>
                                    <td>
                                        <input value={inputs.email} type="text" className='form-control' name="email" onChange={handleChange} />
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <label>Mobile: </label>
                                    </th>
                                    <td>
                                        <input value={inputs.mobile} type="text" name="mobile" className='form-control' onChange={handleChange} />
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <label>Opening Balance: </label>
                                    </th>
                                    <td>
                                        <input value={inputs.opening_balance} type="text" name="opening_balance" className='form-control' onChange={handleChange} />
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="2" align ="right">
                                        <Link to={`/ViewClient`} style={{marginRight: "10px"}} class="btn btn-warning">Cancle Edit</Link>
                                        <button class="btn btn-success">Update</button>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </form>

                </div>

            </div>
        </div>
    )
}

export default EditClient;